import React from 'react';
import styles from './Quiz.module.css';
import { motion, AnimatePresence } from 'framer-motion';
import Question from '../Question/Question';
import VarItem from '../VarItem/VarItem';
import VarItemCorrect from '../VarItemCorrect/VarItemCorrect';
import classNames from 'classnames';
import iactiveLogo from '../../assets/images/iactive_logo.png';
import { VariantsImg } from '../VariantsImg/VariantsImg';

const Quiz = ({
  variants,
  title,
  questionImgUrl,
  currentState,
  questionFontSize,
  answerFontSize,
  varNumFontSize,
}) => {
  const isLong = title?.length > 170;

  const isImgVars = variants && variants.some((v) => v.varImgUrl);

  return (
    <motion.div
      key="quiz"
      style={{ width: '100%' }}
      initial={{ opacity: 0, flex: 1 }}
      animate={{ opacity: 1, flex: 1 }}
      transition={{ duration: 1, delay: 1 }}
      className={classNames(styles.containerQuize, {
        [styles.containerQuize_large]: !questionImgUrl && variants.length <= 1,
      })}>
      <Question
        title={title}
        large={!questionImgUrl && variants.length <= 1}
        questionImgUrl={questionImgUrl}
        isLong={isLong}
        questionFontSize={questionFontSize}
      />

      <div
        className={questionImgUrl ? styles.blockQuiz : styles.blockQuizNoImg}
        key={questionImgUrl}>
        {questionImgUrl && (
          <motion.div
            initial={{
              opacity: 0,
            }}
            animate={{
              opacity: 1,
            }}
            transition={{ duration: 1, delay: 2.5 }}
            className={classNames(styles.blockImgQuestion, {
              [styles.center]: currentState === 'S1' && variants.length <= 1,
            })}>
            <img src={questionImgUrl} alt="" className={styles.questionImg} />
          </motion.div>
        )}
        {isImgVars ? (
          <VariantsImg
            variants={variants}
            varNumFontSize={varNumFontSize}
            currentState={currentState}
          />
        ) : (
          <div
            className={classNames(
              styles[questionImgUrl ? 'vars-wrapper' : 'vars-wrapper-noImg'],
              {
                [styles.hidden]: currentState === 'S1' && variants.length <= 1,
                [styles.onlyAnswer]:
                  !questionImgUrl &&
                  currentState === 'S2' &&
                  variants.length <= 1,
              }
            )}>
            <div
              className={classNames(
                styles[questionImgUrl ? 'vars' : 'vars-noImg'],
                {
                  [styles.correct]:
                    !questionImgUrl &&
                    variants.length <= 1 &&
                    currentState === 'S2',
                }
              )}
              style={{
                gap: questionImgUrl
                  ? variants.filter((el) => el.comment.length > 30).length >= 2
                    ? '1rem'
                    : '2.5rem'
                  : '5rem 3.5rem',
              }}>
              {variants?.map((item, i) => {
                return (
                  <motion.div
                    initial={{
                      opacity: 0,
                      scale: 0,
                      originX: 0,
                      originY: 'center',
                    }}
                    animate={{
                      opacity: 1,
                      scale: 1,
                      originX: 0,
                      originY: 'center',
                    }}
                    transition={{ duration: 1, delay: i * 0.8 + 2.5 }} // 2.5 анимация вопроса
                    key={item.comment}
                    style={{ display: 'flex', alignItems: 'stretch' }}>
                    <div className={styles.varRight}>
                      {questionImgUrl ? (
                        // <AnimatePresence>
                        <>
                          {currentState === 'S2' || !currentState ? (
                            item.correct ? (
                              <VarItemCorrect
                                withImage={Boolean(questionImgUrl)}
                                item={item}
                                i={i}
                                withoutNum={variants.length <= 1}
                                answerFontSize={answerFontSize}
                                varNumFontSize={varNumFontSize}
                                isQuestionImg
                              />
                            ) : (
                              <VarItem
                                item={item}
                                currentState={currentState}
                                i={i}
                                answerFontSize={answerFontSize}
                                varNumFontSize={varNumFontSize}
                                isQuestionImg
                              />
                            )
                          ) : (
                            variants.length > 1 && (
                              <VarItem
                                currentState={currentState}
                                item={item}
                                i={i}
                                answerFontSize={answerFontSize}
                                varNumFontSize={varNumFontSize}
                                isQuestionImg
                              />
                            )
                          )}
                        </>
                      ) : (
                        // </AnimatePresence>
                        <>
                          {currentState === 'S2' || !currentState ? (
                            item.correct ? (
                              <VarItemCorrect
                                withImage={Boolean(questionImgUrl)}
                                item={item}
                                i={i}
                                title={
                                  variants.length <= 1
                                    ? 'Правильный ответ:'
                                    : ''
                                }
                                withoutNum={variants.length <= 1}
                                answerFontSize={answerFontSize}
                                varNumFontSize={varNumFontSize}
                              />
                            ) : (
                              <VarItem
                                currentState={currentState}
                                item={item}
                                i={i}
                                answerFontSize={answerFontSize}
                                varNumFontSize={varNumFontSize}
                              />
                            )
                          ) : (
                            <VarItem
                              currentState={currentState}
                              item={item}
                              i={i}
                              answerFontSize={answerFontSize}
                              varNumFontSize={varNumFontSize}
                            />
                          )}
                        </>
                      )}
                    </div>
                  </motion.div>
                );
              })}
            </div>
          </div>
        )}
      </div>
      <motion.div
        initial={{
          opacity: 0,
        }}
        animate={{
          opacity: 1,
        }}
        transition={{ duration: 1, delay: 1 }}
        className={styles.remark}>
        <div
          style={{
            fontSize:
              variants.filter((el) => el.comment.length > 25).length >= 2
                ? '3rem'
                : '3.5rem',
          }}>
          сделано на базе сервисов
        </div>
        <img
          style={{
            maxWidth:
              variants.filter((el) => el.comment.length > 25).length >= 2
                ? '25rem'
                : '30rem',
          }}
          src={iactiveLogo}
          alt="iactive logo"
        />
      </motion.div>
    </motion.div>
  );
};

export default React.memo(Quiz);
